export default function MySQL_UPPER() {
  return (
    <div>
      <h2>MySQL_UPPER</h2>    </div>
  );
}